export default __webpack_public_path__ + "static/media/germany.78468cba.svg";